import { render, staticRenderFns } from "./canxieManage.vue?vue&type=template&id=83484cd2&"
import script from "./canxieManage.vue?vue&type=script&lang=js&"
export * from "./canxieManage.vue?vue&type=script&lang=js&"
import style0 from "./canxieManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports